import { Injectable, inject } from '@angular/core';
import { SavePinBase } from '../save-pin-base/save-pin-base';

@Injectable({
  providedIn: 'root',
})
export class SavePinService {
  private readonly savePinBase = inject(SavePinBase);

  public async setPin(username: string, pin: string): Promise<void> {
    await this.savePinBase.setPin(username, pin);
  }

  public async getPin(username?: string): Promise<string | null> {
    return await this.savePinBase.getPin(username);
  }

  public async resetPin(username?: string): Promise<void> {
    await this.savePinBase.resetPin(username);
  }
}
